<template>
    <div class="search_box search_wrap">
        <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-width="120px"
            :inline-message="true"
            v-on:submit.prevent="handleClick"
        >
            <el-form-item label="キーワード" prop="keyword">
                <el-input
                    placeholder="キーワードを入力してください"
                    v-model="form.keyword"
                    title="キーワード"
                    clearable
                ></el-input>
            </el-form-item>
            <transition name="expand_div">
                <div v-show="expand">
                    <el-form-item
                        label="データベース"
                        prop="db.checkedDBSelections"
                    >
                        <div class="check_item">
                            <el-checkbox
                                :indeterminate="db.isIndeterminate"
                                v-model="db.checkAllDBSelections"
                                @change="handleCheckAllDBSelectionsChange"
                                ><strong>すべて選択</strong>
                            </el-checkbox>
                            <el-checkbox-group
                                v-model="form.db.checkedDBSelections"
                                @change="handleCheckedDBSelectionsChange"
                            >
                                <el-checkbox
                                    v-for="database in db.databases"
                                    :key="database[0]"
                                    :label="database[0]"
                                >
                                    <strong>{{ database[1] }}</strong>
                                    <span class="note">{{ database[2] }}</span>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </div>
            </transition>
            <el-row class="button_row">
                <el-col :span="12" class="tal">
                    <el-button
                        type="info"
                        class="mgr10 button_info_width"
                        @click="resetInputs"
                    >
                        クリア
                    </el-button>
                </el-col>
                <el-col :span="12" class="tar">
                    <div v-if="expand">
                        <el-button
                            type="info"
                            class="mgl10 button_info_width"
                            icon="el-icon-arrow-up"
                            @click="close"
                        >
                            閉じる
                        </el-button>
                    </div>
                    <div v-if="!expand">
                        <el-button
                            type="info"
                            class="mgl10 button_info_width"
                            icon="el-icon-arrow-down"
                            @click="open"
                        >
                            開ける
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <div class="buttonbox" id="search">
                <el-button
                    type="success"
                    icon="el-icon-search"
                    @click="handleClick"
                >
                    検索する
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { SearchKey } from "../../composables/useAllSearch.js";
import { ValidationConstants } from "@/store/app.config";
import { reactive, toRefs, defineComponent, inject, ref, onMounted } from "vue";

export default defineComponent({
    name: "AllSearchForm",

    setup() {
        // *****************
        // Inject
        // *****************
        const {
            search,
            resetForm,
            form,
            formRef,
            page,
            facetResetFlg,
            firstSearch,
        } = inject(SearchKey);
        let expand = ref("true");
        function open() {
            expand.value = true;
        }
        function close() {
            expand.value = false;
        }

        /* form内データベースチェックボックス部分 */
        const dbSelections = ["paper", "noukigu"];
        const dbContents = [
            [
                dbSelections[0],
                "論文",
                "農林水産関係の学術雑誌や研究報告等に掲載された論文の書誌情報や全文です。",
            ],
            [
                dbSelections[1],
                "農機具",
                "明治時代から100年余りの間に使われていた農具民具等です。本データベースはアーカイブのため、データの追加予定はございません。 ",
            ],
        ];
        let checkAllDB = true;
        if (dbContents.length != form.value.target_range.length) {
            checkAllDB = false;
        }
        const db = ref({
            checkAllDBSelections: checkAllDB,
            checkedDBSelections: form.value.target_range,
            databases: dbContents,
            isInterminate: false,
        });
        const handleCheckAllDBSelectionsChange = (value) => {
            db.value.checkedDBSelections = value ? dbSelections : [];
            form.value.target_range = value ? dbSelections : [];
            db.value.isIndeterminate = false;
        };
        const handleCheckedDBSelectionsChange = (value) => {
            const checkedCount = value.length;
            db.value.checkAllDBSelections =
                checkedCount === db.value.databases.length;
            form.value.target_range = value;
        };

        /* バリデーション*/
        //バリデーションルールを設定
        const data = reactive({
            form: form,
            rules: {
                keyword: [
                    {
                        max: ValidationConstants.INPUT_MAX_SIZE_256.condition,
                        message: ValidationConstants.INPUT_MAX_SIZE_256.message,
                        trigger: "change",
                    },
                ],
                "db.checkedDBSelections": [
                    {
                        required:
                            ValidationConstants.DB_SELECT_REQUIRED.condition,
                        message: ValidationConstants.DB_SELECT_REQUIRED.message,
                        trigger: "change",
                    },
                ],
            },
        });
        data.form["db"] = db;

        //クリアボタン処理
        const resetInputs = async () => {
            db.value.checkedDBSelections = dbSelections;
            db.value.checkAllDBSelections = true;
            await resetForm();
        };

        /* 検索ボタンを押下され、問題無しの場合は、検索実行する */
        const handleClick = () => {
            formRef.value.validate((valid) => {
                if (valid) {
                    execSearch();
                } else {
                    return false;
                }
            });
        };
        //検索実行
        const execSearch = async () => {
            page.value = 1;
            form.value.dbname = [];
            form.value.catyear = [];
            facetResetFlg.value = false;
            await search();
        };

        // 初回検索
        onMounted(async () => {
            firstSearch();
            db.value.checkedDBSelections = form.value.target_range;
            if (dbContents.length != form.value.target_range.length) {
                db.value.checkAllDBSelections = false;
            }
        });

        return {
            /* form用 */
            ...toRefs(data),
            formRef,
            db,
            //画面開閉用
            expand,
            open,
            close,
            /* method */
            handleClick,
            handleCheckAllDBSelectionsChange,
            handleCheckedDBSelectionsChange,
            resetInputs,
        };
    },
});
</script>

<style scoped>
/* search_box */
.search_box {
    padding: 30px 50px 45px;
    background-color: #edf1f1;
}
.search_wrap {
    margin-bottom: 25px;
}
.buttonbox {
    text-align: center;
    margin-top: 10px;
}
.buttonbox button {
    background-color: #188031;
    border-color: #188031;
    width: 300px;
}

.check_item {
    display: table;
    table-layout: fixed;
    color: #1f1f1f;
    display: table;
    padding-left: 27px;
    width: 100%;
}
.check_item strong {
    display: table-cell;
    vertical-align: middle;
    width: 80px;
}

.check_item .note {
    display: table-cell;
    width: 520px;
    white-space: normal !important;
}

.el-checkbox-group {
    margin-left: 20px;
}

.el-checkbox__label strong {
    color: #1f1f1f !important;
}
.el-checkbox__label span.note {
    color: #1f1f1f !important;
}

.button_row {
    margin-left: auto;
    margin-right: auto;
    width: 300px;
}
.button_info_width {
    width: 140px;
}

/* アニメーション中のスタイル */
.expand_div-enter-active,
.expand_div-leave-active {
    transition: all 0.1s ease;
}
.expand_div-enter-from,
.expand_div-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
.expand_div-enter-to,
.expand_div-leave-from {
    opacity: 1;
}
</style>
